import React from 'react';
import { AdminTaskStatus, AdminTaskType } from "../../../../../constants";
import RunPendingKaplanImport from './run-pending-kaplan-import';

const runTaskOption = {
  accept: (taskType, status) => (taskType === AdminTaskType.kaplanImport) && (status === AdminTaskStatus.pending),
  option: (data) => {
    return <RunPendingKaplanImport key='run-pending-kaplan-import' data={data} />
  }
}

export const kaplanImportOptions = [
  runTaskOption
]


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/admin-task-portal/partials/kaplanImportOptions.js